import React, { useState, useEffect } from 'react';
import "./header.css";
import NavBar from '../NavBar';
import profilImage1 from "../../images/profil-1.png";
import profilImage2 from "../../images/profil-2.png";
import Typewriter from "typewriter-effect";

function Header(props) {
  const images = [profilImage1, profilImage2];
  const [profilImageIndex, setProfilImageIndex] = useState(0);
  const [fadeIn, setFadeIn] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeIn(false);

      setTimeout(() => {
        setProfilImageIndex((prevIndex) => (prevIndex + 1) % 2);
        setFadeIn(true);
      }, 500);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <header>
      <div className='header-bg'></div>
      <div className='header-shadow'></div>
      <div className='header-shadow-2'></div>
      <NavBar/>
      <div className={`header-content ${fadeIn ? 'fade-in' : 'fade-out'}`}>
        <div className="header-text">
          <h2>Hello, I'm</h2>
          <p className="name">
          <Typewriter
                options={{
                  autoStart: true,
                  loop: true,
                }}

                onInit={(typewriter) => {
                    typewriter
                        .typeString("Umar Faruq Robbany")
                        .pauseFor(1000)
                        .deleteAll()
                        .typeString("Jira 38")
                        .pauseFor(1000)
                        .start();
                }}
            />
          </p>
          <div className="desc">
            <span className="line"></span>
            Informatics Engineering Student at Bandung State Polytechnic
          </div>
          <div className="more">
            <a className="btn-primary" href="#about">Know More</a>
          </div>
        </div>
        <div className="header-image">
          <img src={images[profilImageIndex]} alt="image"/>
        </div>
      </div>
      <div class="circles-container">
        <div class="circle" id="circle-1"></div>
        <div class="circle" id="circle-2"></div>
        <div class="circle" id="circle-3"></div>
      </div>
    </header>
  );
}

export default Header;
